import { Table } from "antd";
import formatPrice from "../../../components/formatPrice";
import datetimeParser from "../../../components/datetimeParser";

const ExpandPrzekazyRender = (record) => {
	if (record.przekazy && record.przekazy.length > 0) {
		return (
			<div>
				<Table
					rowKey="msr_przekazania_id"
					columns={[
						{
							title: "ID wpływu",
							dataIndex: "msr_wplywy_own_id",
							width: "140px",
							key: "msr_wplywy_own_id",
							render: (item) => (
								<div className="monospace">#{item}</div>
							),
						},
						{
							title: "Kwota przekazu",
							dataIndex: "msr_przekazania_amount",
							key: "msr_przekazania_amount",
							width: "170px",
							render: (item) => (
								<div
									className="monospace"
									style={{
										fontSize: "14px",
										fontWeight: 700,
										textAlign: "right",
									}}
								>
									{formatPrice(item)} zł
								</div>
							),
						},
						{
							title: "Rachunek",
							dataIndex: "msr_bank_accounts_name",
							key: "msr_bank_accounts_name",
							render: (item, row) => (
								<div>
									<div style={{ fontWeight: 500 }}>
										{row.msr_bank_accounts_name}
									</div>
									<div
										className="monospace"
										style={{ opacity: 0.8 }}
									>
										{row.msr_bank_accounts_number}
									</div>
								</div>
							),
						},
						{
							title: "Data wpływu",
							dataIndex: "msr_wplywy_date_in",
							key: "msr_wplywy_date_in",
							width: "140px",
							render: (item) => (
								<div>
									{item && item !== "null"
										? datetimeParser(item, "YYYY-MM-DD")
										: "Brak"}
								</div>
							),
						},
						{
							title: "Data wpływu na rachunek rozliczeniowy",
							dataIndex: "msr_wplywy_date_forward",
							key: "msr_wplywy_date_forward",
							width: "220px",
							render: (item) => (
								<div>
									{item && item !== "null"
										? datetimeParser(item, "YYYY-MM-DD")
										: "Brak"}
								</div>
							),
						},
						{
							title: "Opis z banku",
							dataIndex: "msr_wplywy_bank_desc",
							key: "msr_wplywy_bank_desc",
							render: (item) => (
								<div style={{ fontSize: "13px" }}>
									{item || ""}
								</div>
							),
						},
					]}
					dataSource={record.przekazy}
					pagination={false}
				/>
			</div>
		);
	}
	return null;
};

export default ExpandPrzekazyRender;
